import { Link } from "react-router-dom";
import { Linkedin, ArrowUpRight } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-border bg-background mt-24"
    >
      <div className="container-x py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <p className="eyebrow mb-6">SamStella, LLC</p>
            <p className="font-display text-3xl md:text-4xl tracking-tight leading-[1.05] max-w-md">
              Operator-led. Revenue first. Built for the next era of commerce + media.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="eyebrow mb-5">Navigate</p>
            <ul className="space-y-3 text-sm">
              <li><Link to="/" className="link-underline" data-testid="footer-link-home">Home</Link></li>
              <li><Link to="/about" className="link-underline" data-testid="footer-link-about">About</Link></li>
              <li><Link to="/team" className="link-underline" data-testid="footer-link-team">Team</Link></li>
              <li><Link to="/portfolio" className="link-underline" data-testid="footer-link-portfolio">Portfolio</Link></li>
              <li><Link to="/contact" className="link-underline" data-testid="footer-link-contact">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="eyebrow mb-5">Contact</p>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="mailto:info@samstella.com"
                  className="link-underline"
                  data-testid="footer-email"
                >
                  info@samstella.com
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/company/samstella-llc/"
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 link-underline"
                  data-testid="footer-linkedin"
                >
                  <Linkedin size={14} /> SAMSTELLA LLC
                  <ArrowUpRight size={12} />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-border flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="font-mono-label text-[11px] tracking-[0.22em] uppercase text-muted-foreground">
            © {year} SamStella, LLC — All rights reserved
          </p>
          <p className="font-mono-label text-[11px] tracking-[0.22em] uppercase text-muted-foreground">
            New York / Strategy + Operations
          </p>
        </div>
      </div>
    </footer>
  );
}
